@if (cargando()) {
  <div class="min-h-screen flex flex-col items-center justify-center gap-3 text-[var(--muted)] text-center px-6">
    <p>Cargando…</p>
    @if (tardando()) {
      <p class="text-[12.5px] max-w-xs">
        Está tardando más de lo normal — puede ser la conexión con Supabase. Revisa la consola del navegador (F12) para el detalle del error.
      </p>
      <button (click)="recargar()" class="text-[13px] font-semibold px-4 py-2 rounded-lg border border-[var(--border)]">
        Recargar página
      </button>
    }
  </div>
} @else if (perfil()) {
  <router-outlet />
}
